import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cd7fd79"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onMousedown", "onMouseup"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!

  return (_openBlock(), _createBlock(_component_VueDraggableNext, {
    class: "draggable-block",
    modelValue: _ctx.list,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
    disabled: !_ctx.enabled,
    tag: "transition-group",
    onStart: _ctx.startDrag,
    onEnd: _ctx.endDrag
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (element) => {
        return (_openBlock(), _createElementBlock("div", {
          key: element.id,
          class: _normalizeClass(element.type === 'slot' ? _ctx.slotClasses : _ctx.videoBlockClasses),
          onMousedown: ($event: any) => (element.type === 'video' && _ctx.setActiveBorder(true)),
          onMouseup: ($event: any) => (element.type === 'video' && _ctx.setActiveBorder(false))
        }, null, 42, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "disabled", "onStart", "onEnd"]))
}